<template>
	<div ref="chartContainer" class="chart-container" style="height: 300px;width:100%;"></div>
</template>
<script>
// import * as echarts from 'echarts';
export default {
	name: 'kl_radar_chart',
	props: {
		drivingScore: Array, // 接收外部传入的评分数据
	},
	data() {
		return {
			chart: null,
			// 存储处理后的评分数据
			scoreData: []
		}
	},
	// 关键修复：监听数据变化，及时更新图表
	watch: {
		drivingScore: {
			handler(newVal) {
				this.processData(newVal);
				this.updateChart();
			},
			deep: true,
			immediate: true // 初始化时就执行一次
		}
	},
	mounted() {
		this.initChart();
		window.addEventListener('resize', this.resizeChart);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.resizeChart);
		if (this.chart) {
			this.chart.dispose();
			this.chart = null;
		}
	},
	methods: {
		// 处理数据：提取Score并确保顺序正确
		processData(data) {
			if (!data || !Array.isArray(data)) {
				this.scoreData = [0, 0, 0, 0];
				return;
			}

			// 按固定顺序提取数据（经济性、安全性、舒适性、护车性）
			const scoreMap = {
				'经济性': 0,
				'舒适性': 0,
				'安全性': 0,
				'护车性': 0
			};

			// 填充实际数据
			data.forEach(item => {
				if (scoreMap.hasOwnProperty(item.GItemType)) {
					scoreMap[item.GItemType] = item.Score || 0;
				}
			});
			// 转换为数组并保持固定顺序
			this.scoreData = [
				scoreMap['经济性'],
				scoreMap['舒适性'],
				scoreMap['安全性'],
				scoreMap['护车性']
			];
		},

		initChart() {
			const chartDom = this.$refs.chartContainer;
			if (!chartDom) return;

			// 销毁已有实例，避免重复初始化
			if (this.chart) {
				this.chart.dispose();
			}

			this.chart = echarts.init(chartDom);
			this.updateChart(); // 初始化时就绘制图表
		},

		// 单独的更新图表方法，方便数据变化时调用
		updateChart() {
			if (!this.chart) return;

			const option = {
				grid: {
					left: '15%', // 左边距
					right: '15%', // 右边距
					top: '10%', // 上边距
					bottom: '10%' // 下边距
				},
				legend: {
					data: [this.$t('driver.驾驶评分')],
					show: false
				},
				tooltip: {
					trigger: 'item'
				},
				radar: {
					center: ['50%', '50%'],  // 居中显示
					radius: '48%',
					indicator: [{
						name: `${this.$t('driver.经济性')} ${this.scoreData[0]}`,
						max: 100
					},
					{
						name: `${this.$t('driver.舒适性')} ${this.scoreData[2]}`,
						max: 100
					},
					{
						name: `${this.$t('driver.安全性')} ${this.scoreData[1]}`,
						max: 100
					},
					{
						name: `${this.$t('driver.护车性')} ${this.scoreData[3]}`,
						max: 100
					}
					],
					axisName: {
						color: '#333333'
					}
				},
				series: [{
					name: this.$t('driver.驾驶评分'),
					type: 'radar',
					data: [{
						value: this.scoreData, // 使用处理后的分数数组
						name: '驾驶评分'
					}],
					lineStyle: {
						color: 'rgba(42, 122, 255, 1)'
					},
					areaStyle: {
						color: 'rgba(42, 122, 255, 0.2)'
					}
				}]
			};

			this.chart.setOption(option);
		},

		resizeChart() {
			if (this.chart) {
				this.chart.resize();
			}
		}
	}
}
</script>
<style scoped>
.chart-container {
	width: 100%;
	height: 100%;
	min-height: 300px;
}
</style>